/* ==========================================================================
   MN — PANIER
   Ajout AJAX, tiroir panier, quick add, mise a jour des quantites.

   Note d'architecture : le tiroir panier est un SNIPPET, pas une section.
   L'API Section Rendering reinjecterait un HTML de section obsolete et
   ecraserait les modifications faites cote client. On re-rend donc le
   contenu du tiroir en JS a partir de /cart.js.
   ========================================================================== */
(function () {
  'use strict';

  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const MN = (window.MN = window.MN || {});
  const T = () => (window.mnStrings || {});

  /* ----------------------------------------------------------------------
     Appels API
     ---------------------------------------------------------------------- */
  const api = {
    get: () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()),

    add: (items) =>
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      }).then(async (r) => {
        const data = await r.json();
        if (!r.ok) throw new Error(data.description || data.message || 'Error');
        return data;
      }),

    change: (line, quantity) =>
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      }).then((r) => r.json())
  };

  /* ----------------------------------------------------------------------
     Rendu du contenu du tiroir
     ---------------------------------------------------------------------- */
  function itemHTML(item, index) {
    const img = item.image
      ? `<img src="${item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')}" alt="" width="72" height="72" loading="lazy">`
      : '';
    const variant =
      item.variant_title && item.variant_title !== 'Default Title'
        ? `<div class="mn-cart-item__variant">${item.variant_title}</div>`
        : '';
    const compare =
      item.original_line_price > item.final_line_price
        ? `<span class="mn-price__compare">${MN.formatMoney(item.original_line_price)}</span>`
        : '';

    /* Choix pot par pot des lots : le client doit pouvoir relire ce qu'il a choisi.
       Les proprietes prefixees par « _ » sont internes a Shopify, on ne les montre pas. */
    const esc = (t) =>
      String(t).replace(/[&<>"']/g, (ch) =>
        ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch])
      );
    const props = Object.keys(item.properties || {})
      .filter((k) => k && k.charAt(0) !== '_' && item.properties[k])
      .map((k) => `<div class="mn-cart-item__variant">${esc(k)}: ${esc(item.properties[k])}</div>`)
      .join('');

    return `
      <div class="mn-cart-item" data-line="${index + 1}">
        <div class="mn-cart-item__media">${img}</div>
        <div>
          <a class="mn-cart-item__title" href="${item.url}">${item.product_title}</a>
          ${variant}
          ${props}
          <div class="mn-price__row" style="margin-top:6px">
            ${compare}
            <span class="mn-price__final" style="font-size:16px">${MN.formatMoney(item.final_line_price)}</span>
          </div>
          <div style="display:flex;align-items:center;justify-content:space-between;gap:12px;margin-top:8px">
            <div class="mn-qty">
              <button class="mn-qty__btn" type="button" data-qty="-1" aria-label="${T().decrease || '-'}">&minus;</button>
              <input class="mn-qty__input" type="number" min="0" value="${item.quantity}" data-qty-input
                     aria-label="${T().quantity || 'Quantity'}" inputmode="numeric">
              <button class="mn-qty__btn" type="button" data-qty="1" aria-label="${T().increase || '+'}">&plus;</button>
            </div>
            <button class="mn-cart-item__remove" type="button" data-remove
                    style="font-size:12px;color:var(--mn-secondary);text-decoration:underline">
              ${T().remove || 'Remove'}
            </button>
          </div>
        </div>
      </div>`;
  }

  function shippingBarHTML(cart) {
    const threshold = (window.mnSettings && window.mnSettings.freeShippingThreshold) || 0;
    if (!threshold) return '';
    const remaining = Math.max(0, threshold - cart.total_price);
    const pct = Math.max(0, Math.min(100, (cart.total_price / threshold) * 100));
    const label = remaining
      ? (T().shippingRemaining || 'Only {amount} to free shipping').replace('{amount}', MN.formatMoney(remaining))
      : T().shippingUnlocked || 'Free shipping unlocked';
    return `
      <div class="mn-shipbar">
        <span class="mn-shipbar__label">${label}</span>
        <span class="mn-shipbar__track"><span class="mn-shipbar__fill" style="width:${pct}%"></span></span>
      </div>`;
  }

  MN.renderCart = function (cart) {
    /* Pastille du header */
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });

    const drawer = MN.drawers && MN.drawers.cart;
    if (!drawer) return;

    const body = $('[data-cart-body]', drawer);
    const footer = $('[data-cart-footer]', drawer);
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML = `<p style="padding:32px 0;text-align:center;color:var(--mn-secondary)">${
        T().cartEmpty || 'Your cart is empty'
      }</p>`;
      if (footer) footer.hidden = true;
      return;
    }

    body.innerHTML = shippingBarHTML(cart) + cart.items.map(itemHTML).join('');
    if (footer) {
      footer.hidden = false;
      const total = $('[data-cart-total]', footer);
      if (total) total.textContent = MN.formatMoney(cart.total_price);
    }
  };

  MN.refreshCart = () => api.get().then((cart) => { MN.renderCart(cart); return cart; });

  /* ----------------------------------------------------------------------
     Quick add depuis une carte produit
     - Produit a variante unique : ajout direct
     - Produit a plusieurs variantes : ouverture de la modale
     ---------------------------------------------------------------------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.dataset.variantId;
    const productUrl = btn.dataset.productUrl;

    /* Plusieurs variantes -> modale de selection */
    if (!variantId && productUrl) return MN.openQuickAdd(productUrl, btn);

    btn.classList.add('is-loading');
    btn.disabled = true;
    try {
      await api.add([{ id: Number(variantId), quantity: 1 }]);
      const cart = await MN.refreshCart();

      /* Retour visuel : coche verte pendant 1,4 s */
      const success = btn.parentElement && $('.mn-card__quick-success', btn.parentElement);
      if (success) {
        success.classList.add('is-visible');
        setTimeout(() => success.classList.remove('is-visible'), 1400);
      }
      if (window.mnSettings && window.mnSettings.openCartOnAdd) {
        setTimeout(() => MN.drawers.cart && MN.drawers.cart.open(btn), 350);
      }
      document.dispatchEvent(new CustomEvent('mn:cart:added', { detail: { cart } }));
    } catch (err) {
      MN.toast(err.message);
    } finally {
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }
  });

  /* ----------------------------------------------------------------------
     Modale quick add — charge le formulaire produit isole
     ---------------------------------------------------------------------- */
  MN.openQuickAdd = async function (productUrl, opener) {
    const modal = $('[data-quick-add-modal]');
    if (!modal) { window.location.href = productUrl; return; }

    const panel = $('[data-quick-add-content]', modal);
    panel.innerHTML = `<div style="padding:48px;text-align:center">${T().loading || 'Loading...'}</div>`;
    modal.classList.add('is-open');
    document.body.classList.add('mn-no-scroll');

    try {
      const sep = productUrl.includes('?') ? '&' : '?';
      const html = await fetch(productUrl + sep + 'section_id=mn-quick-add').then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const content = $('[data-quick-add-inner]', doc);
      panel.innerHTML = content ? content.innerHTML : '';
      MN.init(panel);
      MN.releaseQuickAdd = MN.trapFocus(panel, opener);
    } catch (err) {
      panel.innerHTML = `<div style="padding:48px;text-align:center">${T().error || 'Error'}</div>`;
    }
  };

  MN.closeQuickAdd = function () {
    const modal = $('[data-quick-add-modal]');
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('mn-no-scroll');
    if (MN.releaseQuickAdd) MN.releaseQuickAdd();
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-quick-add-close]')) MN.closeQuickAdd();
    const modal = $('[data-quick-add-modal]');
    if (modal && e.target === modal) MN.closeQuickAdd();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') MN.closeQuickAdd(); });

  /* ----------------------------------------------------------------------
     Formulaires d'ajout au panier (page produit + modale)
     ---------------------------------------------------------------------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();

    const submit = $('[type="submit"]', form);
    const id = $('[name="id"]', form);
    if (!id || !id.value) return;

    if (submit) { submit.disabled = true; submit.classList.add('is-loading'); }

    try {
      const qtyInput = $('[name="quantity"]', form);
      /* Les choix pot par pot des lots voyagent en proprietes de ligne :
         le prix de la ligne reste celui du lot, rien ne touche au mapping du checkout. */
      const props = {};
      $$('[name^="properties["]', form).forEach((el) => {
        const m = el.name.match(/^properties\[(.*)\]$/);
        if (m && el.value) props[m[1]] = el.value;
      });
      const item = { id: Number(id.value), quantity: Number(qtyInput ? qtyInput.value : 1) };
      if (Object.keys(props).length) item.properties = props;
      await api.add([item]);
      const cart = await MN.refreshCart();
      MN.closeQuickAdd();
      if (MN.drawers && MN.drawers.cart) MN.drawers.cart.open(submit);
      document.dispatchEvent(new CustomEvent('mn:cart:added', { detail: { cart } }));
    } catch (err) {
      MN.toast(err.message);
    } finally {
      if (submit) { submit.disabled = false; submit.classList.remove('is-loading'); }
    }
  });

  /* ----------------------------------------------------------------------
     Quantites dans le tiroir
     ---------------------------------------------------------------------- */
  document.addEventListener('click', async (e) => {
    const qtyBtn = e.target.closest('[data-qty]');
    const removeBtn = e.target.closest('[data-remove]');
    if (!qtyBtn && !removeBtn) return;

    const item = (qtyBtn || removeBtn).closest('[data-line]');
    if (!item) return;
    const line = Number(item.dataset.line);

    let quantity = 0;
    if (qtyBtn) {
      const input = $('[data-qty-input]', item);
      quantity = Math.max(0, Number(input.value) + Number(qtyBtn.dataset.qty));
    }
    const cart = await api.change(line, quantity);
    MN.renderCart(cart);
  });

  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-qty-input]');
    if (!input) return;
    const item = input.closest('[data-line]');
    const cart = await api.change(Number(item.dataset.line), Math.max(0, Number(input.value)));
    MN.renderCart(cart);
  });

  /* ----------------------------------------------------------------------
     Selecteur de variantes (page produit et modale)
     Sortie anticipee si aucun selecteur : un produit sans option ne doit
     jamais etre marque « epuise » a cause d'un tableau d'options vide.
     ---------------------------------------------------------------------- */
  MN.initVariantPicker = function (root) {
    const picker = root.querySelector('[data-variant-picker]');
    if (!picker) return;

    const dataEl = $('[data-variant-json]', picker);
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);

    const groups = $$('[data-option-index]', picker);
    if (!groups.length) return; /* produit sans option : on ne touche a rien */

    const idInput = $('[name="id"]', picker.closest('form') || root);
    const priceEl = $('[data-product-price]', root);
    const submitEl = $('[data-product-submit]', root);

    function selected() {
      return groups.map((g) => {
        const active = $('[aria-checked="true"]', g);
        return active ? active.dataset.value : null;
      });
    }

    function apply() {
      const chosen = selected();
      const match = variants.find((v) => chosen.every((val, i) => val === null || v.options[i] === val));
      if (!match) return;

      if (idInput) idInput.value = match.id;
      if (priceEl) {
        priceEl.innerHTML = MN.formatMoney(match.price);
        priceEl.classList.toggle('mn-price--on-sale', !!(match.compare_at_price && match.compare_at_price > match.price));
      }
      if (submitEl) {
        submitEl.disabled = !match.available;
        submitEl.textContent = match.available
          ? T().addToCart || 'Add to cart'
          : T().soldOut || 'Sold out';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      if (root === document) window.history.replaceState({}, '', url);
    }

    groups.forEach((group) =>
      group.addEventListener('click', (e) => {
        const pill = e.target.closest('[data-value]');
        if (!pill) return;
        $$('[data-value]', group).forEach((p) => p.setAttribute('aria-checked', 'false'));
        pill.setAttribute('aria-checked', 'true');
        apply();
      })
    );

    apply();
  };

  /* ----------------------------------------------------------------------
     Toast
     ---------------------------------------------------------------------- */
  MN.toast = function (message) {
    if (!message) return;
    let el = $('#mn-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'mn-toast';
      el.setAttribute('role', 'status');
      el.style.cssText =
        'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:1000001;' +
        'padding:12px 20px;border-radius:8px;background:#141618;color:#fff;font-size:14px;' +
        'max-width:calc(100vw - 32px);text-align:center;opacity:0;transition:opacity .2s';
      document.body.appendChild(el);
    }
    el.textContent = message;
    requestAnimationFrame(() => (el.style.opacity = '1'));
    clearTimeout(el._t);
    el._t = setTimeout(() => (el.style.opacity = '0'), 3200);
  };

  /* ----------------------------------------------------------------------
     Initialisation
     ---------------------------------------------------------------------- */
  function boot() {
    MN.initVariantPicker(document);
    MN.refreshCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', (e) => MN.initVariantPicker(e.target));
})();